var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_253_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_253_11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_253_11",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_253_11",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAES0lEQVR4nO2dTYgcRRTHK5HED4JRJCY7702Csoqumq03gybxkhwU1nlv8kEc9epFFD0oeBRyjAkBPXkQETFxJVe9eBVE9KYkaowaJXjxIEESUMFsS/WKByFt93TN1nTP/wfvtnRNvd/8p7+2u5wDAAAAAAAAgAawMFrYKNZ9UpSWRfmcGF8R42zG60reC6Xl3rDzROjRmsgQo8Pe6IcpaEA2zeWNvu8pH5qYiNHIXSdGJ1JPVJpWSsfdEbc+uhDI4DppORZbxuHk3zRrdi0aH4wiI+ycwu9h6glJ00vpQpQdfX40lXoy1o7ySqPaQrzR+6knIq0pOhUhIXw+/US4HaV8rr4Q5cvJJ2ItKeXLMRKSfiLWnoIQSy8BQix94yHE0jcbQix9gyHE0je12UKUvvLafc4r3bV7xDeG2vlY525RfmEWz3FcWiH0RtH1m717d9zgld9N3SSZBSHe6CPn3Loy91m88WepGyVtF7KotK/0GNrdn7pR0nYhC6Mtm8qO8YBuvzV1o6TtQvqP3Lm57Bjhb1M3StouxCsNSo8x4KXUjZL2C+FPww77fwc44tZ7o49TN0raLiQvpeW+zd10rW3PL81fL0pvpW6SzIyQVSkXxOilxWH3viAnlAy23dszfl6Mv03dIJk5IagMQmx6vwhIiKWXACGWvvEQYumbDSGWvsGNERJrHBft89IZb/yaH3YPhEPw+4d3bM2vNC9t2+L3b1/ww+6j3vhVMf4CQiYnZGX1ARraXWUbfZu7R4zfEeWrSIjFEeKVv+wPaJergR90HvbGP+Eny+oJ8Upvh7uRLgIPHuzcJkafYx9iYwt5vcydyirktweUzmKnbmMclUzi8bEgesjzMR5unbmjrEnSU3oRQqbtcXClH5GQKcIbvwwhEQj3YcINsbrbyU8klf/CPmQMxDp7vPJpUbr074mi0c9i/GY4Wx97u8qfQEhFxPiVwjNtpT/DXcuxtq18FEIqIMZPl2zYiig/5SrilR6HkJIsHthxixj9Wrphyr88tDR/s6tA3+Z6EFISsc6zVZvVU3rGVWDnoa23Q0hJvPKHVZvllT9wFcj/cwZn6uXwyhfHEHLRVWMdhJREjP6oLMTo9+rj4FpWI669xR5n6iboGvZ5IeQ/QAgSkiEhBSAhSEiGhBSAhCAhGRJSABKChGRISAFICBKSISEFICFISIaEFICEICEZElIAEoKEZEhIAUgIEpI1IiEohhBpwBcBCbH0EiDE2iwEC7pksWR4o99i/GTN3FvfZELllb+JkBB6L/VEpCUVXqteW0hYaDf1RKQlFR70qS2k3+9v8ErfpZ6MNLzCgs7RVpAOqx6nnpA0u1bC++1dTMKqx1MwsayRpXzURWf1DdTHkk/OGlUr4aVok3r/Sk5Y9Rj7FC4j43x4e51bC/7Z0Y/C2q7h2Bonj5yv4umNvvbGJ8PRVOjRmsgAAAAAAAAAAFePvwFVquO/weTDjwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.50d354f3f4cc31579a972f928aaabda5.svg";
export { ForwardRef as ReactComponent };